import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import RateService from "../../../../services/catalogs/RateService";

export const REQUEST_CREATE_RATE = "REQUEST_CREATE_RATE";
export const CREATE_RATE_SUCCESS = "CREATE_RATE_SUCCESS";
export const CREATE_RATE_ERROR = "CREATE_RATE_ERROR";

function requestCreateRate() {
  return {
    type: REQUEST_CREATE_RATE,
  };
}

function createRateSuccess(json) {
  return {
    type: CREATE_RATE_SUCCESS,
    message: json.data,
  };
}

function createRateError(json) {
  return {
    type: CREATE_RATE_ERROR,
    error: json.data,
  };
}

export function createRate(payload) {
  return (dispatch) => {
    dispatch(requestCreateRate());
    return RateService.postRate(payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(createRateSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createRate(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createRateError(json.data));
      }
    });
  };
}
